<div nz-row>
  <div nz-col nzSpan="12">
    <div id="chart1" echarts [options]="options" theme="macarons" (chartClick)="onClick($event)"></div>
  </div>
</div>
